module.exports = __webpack_public_path__ + "static/appstore-1dd70e6f454d640f1e22bad5e22354c3.png";